import React                        from "react";
import { Button,makeStyles,Grid}    from "@material-ui/core";

const useStyles = makeStyles(theme=>({
  welcomePageContainer: {
    background:'#FFFDFD',
    height:'calc(100vh - 79.5px)',
  },
  ContainerIzquierdo:{
    width:'97%',
    [theme.breakpoints.down(1160)]:{
      width:'100%',
    },
  },

    ContainerEstrategi:{
    position:'relative',
    width:'100vw',
    height:'calc(100vh - 79.5px - 79.5px)',
    overflow: 'auto',
  },
  ContainerSubHabilidades:{
    background:'none',
    boxSizing:'border-box',
    cursor:'pointer',
    textAlign:'center',
    display:'flex',
    padding:'43px 17px 9px 17px',
    alignItems:'center',
    position:'absolute',
    height:'40px',
    width:'62px',
    right:'3%',
    zIndex:5,
    [theme.breakpoints.down(1281)]:{
      left:'calc(50% - 31px)',
      padding:'0 0 0 62px',
    },
    [theme.breakpoints.down(600)]:{
      left:'0',
      padding:'0 15px 0 55px',
    },
    '& .Habilidades':{
      color:'#575757',
      font: 'normal 18px Lato',
      letterSpacing: '0.13px',
      display:'none',
      background:'FFFDF8',
      [theme.breakpoints.down(1281)]:{
        padding:'0 ', 
        margin:'0',
        font: ' 16px Lato',
      },
      [theme.breakpoints.down(600)]:{
        padding:'0 ', 
        margin:'0',
        font: ' 14px Lato',
      },
    },
    '&:hover':{
      border:' 5px solid #F26973',
      borderRadius: '20px 0px 20px 20px',
      background:'#fff',
      height:'215px',
      width:'233px',
      [theme.breakpoints.down(1281)]:{
        height:'75px',
        width:'350px',
        borderRadius: '0px 0px 20px 20px',
      },
      [theme.breakpoints.down(600)]:{
        height:'75px',
        width:'100%',
      },

      '& .Habilidades':{
        display:'block',
      },
      '&:before':{
        borderTop:' 0px ',
        borderRight:'0px'
      },
    },
    '&:before':{
      display:'flex',
      justifyContent:'center',
      alignItems:'center',
      content: '"RG"',
      position: 'absolute',
      right: '0',
      top: '0',
      font: '20px Fredoka One',
      background: '#DC3F8C',
      color: '#FFF',
      border:' 3px solid #F2624F',
      borderRadius: '0px 0px 20px 20px',
      height: '40px',
      width: '62px',
      [theme.breakpoints.down(1281)]:{
        left: '-5px',
        top: '0',
      },
      [theme.breakpoints.down(600)]:{
        height: '30px',
        width: '52px',
        font: '18px Fredoka One',
      },

    },
  },

  Estrategia:{
    margin:'0px',
    font:'38px Fredoka One',
    textAlign: 'center',
    letterSpacing: '0.28px',
    color: '#20A698',
    opacity: '1',
    [theme.breakpoints.down(1161)]:{
      font:'28px Fredoka One',
    },
    [theme.breakpoints.down(600)]:{
      font:'24px Fredoka One',
    },
  },

   TextStrg:{
      margin:'0', 
      font:'normal  22px Lato',
      letterSpacing: '0.10px',
      color: '#575757',
      opacity: 1,
      padding:'0 0 40px 0',
      boxSizing:'border-box',
      width:'760px',
      [theme.breakpoints.down(1161)]:{
        width:'650px',
        font:'normal  18px Lato',
      },
      [theme.breakpoints.down(600)]:{
        font:'normal  16px Lato',
        width:'325px',
      },
      [theme.breakpoints.down(325)]:{
        font:'normal  14px Lato',
        width:'300px',
      },
  },

   Titulo:{
    position:'absolute',
    top:'58px',
    [theme.breakpoints.down(1161)]:{
      top:'80px',
    },
  },
  Objet1:{
    position:'absolute',
    top:'130px',  
    '& .Td':{
      height:'42px',
      width:'500px',
      border:'solid 1px #000',
      boxSizing:'border-box',
      padding:'0 0 5px 10px',
      font:'normal  22px Lato',
      letterSpacing: '0.10px',
      color: '#575757',
      textAlign:'center',
      [theme.breakpoints.down(1161)]:{
        font:'normal  18px Lato',
      },
      [theme.breakpoints.down(600)]:{
        font:'normal  16px Lato',
      },
    },
    '& .Br':{
      margin:'0 0 20px 0'
    },
    '& .ul':{
      margin:'22px 0',
      padding:'0 0 0 22px',
    },
    '& .li':{
      marginBottom:'10px',
    },
   '& .Amarillo':{
    background:'#F7DF92',
   },
   '& .Verde':{
    background:'#84E9DF',
   },
  },


  ContainerBarraInferior:{
    position:'relative',
    background:'#F3CD52',
    height:'79.51px',
    [theme.breakpoints.up(1920)]:{
      height:'8vh',
    },
    [theme.breakpoints.down(1161)]:{
      background: 'linear-gradient(280deg, #D3348F 0%, #F1CB5A 100%) 0% 0% ',
    },
  },

  ContainerBarraDerecha:{
    background: 'linear-gradient(180deg, #D3348F 0%, #F1CB5A 100%) 0% 0%',
    width:'3%',
    height:'100vh',
    [theme.breakpoints.down(1161)]:{
      display:'none',
    },
  },
  
   BotonAvanza:{
    position:'absolute',
    bottom:'52px',
    right:'134px',
    textTransform:'none',
    textDecoration:'none',
    height:'62px',
    width:'279px',  
    background: '#7A54BA',
    boxShadow: '0px 3px 6px #00000029',
    borderRadius: '61px',
    color: '#FFFFFF',
    font: 'bold 20px lato ',
    '&:hover':{
        background: '#dd78fb',
      },
    [theme.breakpoints.down(1161)]:{
      position:'relative',
      bottom:'32px',
      left:'0',
      right:'0',
    },
  },

    
}));

const ReadingStrategys = (props) => {
  const classes = useStyles();
  const {activeStep, setActiveStep, handleNextStep} = props

  const handleContinue = () => {
    setActiveStep(activeStep + 1)
    handleNextStep()
  }

  return(

    <Grid  container direction="column" item sm={12} className={classes.welcomePageContainer} >
<div className={classes.ContainerSubHabilidades}>
          <p className="Habilidades">Identificar el verbo (con persona, tiempo y modo) de una oración.</p>
      </div>
      <Grid container item sm={12} justifyContent="center" className={classes.ContainerIzquierdo} >

        <Grid container item className={classes.ContainerEstrategi } >

              <Grid container item justifyContent="center" alignItems="center" sm={12} className={classes.Titulo}> 
                <p className={classes.Estrategia} >Estrategia de lectura</p>
              </Grid>

              <Grid container item sm={12} alignItems="center" justifyContent="center" className={classes.Objet1}>
                  <p className={classes.TextStrg}>
                    Al leer una historia vemos que los personajes realizan una gran diversidad 
                    de acciones, las cuales imaginamos. Sigue estos pasos, uno a uno, para descubrir 
                    la importancia que tienen los verbos y su conjugación.
                    <ul className="ul">
                      <li className="li">
                        Escribe en una hoja las respuestas a las siguientes preguntas:
                      </li>
                      <ol type="a" start={"a"} className="ul">
                        <li className="li">
                          ¿Qué indica un verbo en una oración? ¿Qué pregunta realizas para identificar la acción de un sujeto?
                        </li>
                        <li className="li">
                          ¿Cuáles tiempos y modos verbales recuerdas?
                        </li>
                        <li className="li">
                          ¿Qué pronombres corresponden a la 1ª, 2ª y 3ª personas del singular? ¿Cuáles corresponden a las personas del plural?
                        </li>
                      </ol>

                      <li className="li">
                        Lee las tres primeras oraciones de la historia que tiene por título <em>Puentes</em> e identifica los verbos.
                      </li>
                      <li className="li">
                        Vuelve a leer el texto, pero ahora omite los verbos que identificaste.
                      </li>
                      <li className="li">
                        Escribe en tu hoja qué experimentaste como lector al omitir los verbos del texto.
                      </li>
                      <li className="li">
                        Ahora, elabora una tarjeta con papel o cartón reciclado para cada verbo que identificaste en tu primera lectura.
                      </li>

                      <li className="li">
                        Anota la información que corresponda a cada uno de los verbos. Tus tarjetas seguirán este ejemplo.
                      </li>


                    </ul>
                  <tr>
                    <tr>
                      <td valign="middle" className="Td Verde"><b>Verbo</b></td>
                      <td valign="middle" className="Td ">Cree</td>
                    </tr>
                    <tr>
                      <td valign="middle" className="Td Verde"><b>Infinitivo</b></td>
                      <td valign="middle" className="Td ">Creer </td>
                    </tr>
                    <tr>
                      <td valign="middle" className="Td Verde"><b>Tiempo</b></td>
                      <td valign="middle" className="Td ">Presente </td>
                    </tr>
                    <tr>
                      <td valign="middle" className="Td Verde"><b>Persona</b></td>
                      <td valign="middle" className="Td ">3ª persona: él</td>
                    </tr>
                    <tr>
                      <td valign="middle" className="Td Verde">Número</td>
                      <td valign="middle" className="Td ">Singular </td>
                    </tr>
                    <tr>
                      <td valign="middle" className="Td Verde">Modo</td>
                      <td valign="middle" className="Td ">Indicativo </td>
                    </tr>
                  </tr>

                    <ul className="ul">
                      <li className="li">
                        Revisa todas tus tarjetas al terminar. ¿Cuántas tienes? ¿Ocho? ¡Muy bien! Ahora sabes lo que hace y 
                        siente Minueto, uno de los personajes de esta historia. No te preocupes si identificaste menos de 
                        ocho verbos. Serás especialista en identificarlos a lo largo de la sesión. ¡Avanza!
                      </li>
                    </ul>

                  </p>
              </Grid>
                
        </Grid>
        
        <Grid container item sm={12} className={classes.ContainerBarraInferior} justifyContent="center">
            <Button id="BotonContinuarEstrategias" className={classes.BotonAvanza} onClick={handleContinue}>
              Continuar
            </Button>
        </Grid>
        
      </Grid>

      <Grid container item sm={12} className={classes.ContainerBarraDerecha}></Grid>

    </Grid>

  )
}

export default ReadingStrategys;
